export default __webpack_public_path__ + "static/media/txt.54298984.svg";